import { useQuery } from "@tanstack/react-query";
import { VesselTypeInterface } from "@/types/apiTypes";
import { fetchVesselTypesApi } from "@/API/fetchVesselTypesApi";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";
import { ShowNotification } from "@/components/ShowNotification";

export const useFetchVesselTypes = () => {
  const { startLoading, stopLoading } = useLoadingContext();

  return useQuery<VesselTypeInterface[], Error>({
    queryKey: ["vesselTypes"],
    queryFn: async () => {
      startLoading();

      try {
        return await fetchVesselTypesApi();
      } catch (error) {
        ShowNotification({
          title: "Error",
          message: "Failed to fetch vessel types.",
          color: "error",
        });
        throw error;
      } finally {
        stopLoading();
      }
    },
    staleTime: 1000 * 60 * 5,
  });
};
